import { createIconComponent } from '../../factory/create-icon-component';
export const Export3RecIcon = createIconComponent(
  'Export3RecIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 16C2 12.6863 4.68629 10 8 10H16C19.3137 10 22 12.6863 22 16C22 19.3137 19.3137 22 16 22H8C4.68629 22 2 19.3137 2 16Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M12 16V2M12 2L8 6M12 2L16 6"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
);
